<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6" >
            <a-form-model-item label="按类型统计">
              <a-select
                v-model="formInline.goodsType"
                placeholder="请选择类型"
                style="width: 250px"
              >
                <a-select-option
                  v-for="item in tranList"
                  :key="item.goodsType"
                  :value="item.goodsType"
                  default-value=""
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="下单时间" prop="store">
              <a-range-picker @change="onChange" v-model="formInline.createTime" format="YYYY-MM-DD" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">

        <goodOrderContent :formInline="formInline"
          ref="isson">
        </goodOrderContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>

</template>

<script>
import goodOrderContent from './mallGoodOrderContent.vue';
export default {
  components: {
    goodOrderContent,
  },
  data() {
    return {
      formInline: {
        goodsType:'',
        endDate: "",
        startDate: "",

      },
      xiala:[],
      tranList:[
        { goodsType: "", name: "全部套餐" },
        { goodsType: "654", name: "代币套餐" },
        { goodsType: "655", name: "门票套餐" },
      ],
      
    };
  },
  created() {

  },
  methods: {    
    storeType(e) {
      this.formInline.store = e
      console.log('oooooooooooooooooop', e)
    },
    seach(e) {
      console.log(this.formInline);
      this.$refs.isson.query();
    },
    onChange(date, dateString) {
      console.log(dateString)
      this.formInline.endDate = dateString[1]
      this.formInline.startDate = dateString[0]
    },
    handleSubmit(e) {
      console.log(this.formInline);
      this.$refs.isson.query();

    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.formInline = {
        goodsType:"",
        endDate: "",
        startDate: "",
        createTime: ""
      }
      this.$refs.isson.pagination= {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      this.$refs.isson.sumPrice = 0;
       this.$refs.isson.getAlreadyPayData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/mallGoodOrderCount/mallGoodOrderHome.vue